export default __webpack_public_path__ + "static/media/back.9f66ee4d.svg";